// extracted by mini-css-extract-plugin
module.exports = {"tabs":"List_style_tabs__2lt_c","userName":"List_style_userName__2sx95","tip":"List_style_tip__1P64T"};